import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_getGifts = async (pageNo?: number, pageSize?: number) => {
	const page_number = pageNo || 1;
	const page_size = pageSize || 10;
	const uri = `${BASE_URL}/gifts/?page=${page_number}&offset=${page_size}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`, // Add bearer token
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getGiftsByFilter = async (searchString: string) => {
	const uri = `${BASE_URL}/gifts/filter?searchString=${searchString}`;
	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getGiftById = async (id: string, userId: string) => {
	const uri = `${BASE_URL}/gifts/getById/${id}/${userId}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};

export const api_getGiftByCategory = async (
	categoryId: string,
	pageNo: number,
	pageSize: number,
) => {
	try {
		const uri = `${BASE_URL}/gifts/getByCategory?page=${pageSize}&offset=${pageNo}&categoryId=${categoryId}`;
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		if (!response.ok) {
			throw new Error('Failed to fetch gifts by category');
		}

		const data = await response.json();
		const isSuccess = response.status >= 200 && response.status < 300;
		return { isSuccess, data: data };
	} catch (error) {
		console.error('Error fetching gifts by category:', error);
		return { isSuccess: false, message: 'Error fetching gifts by category' };
	}
};

export const api_getGiftByName = async (value: string, pageNo: number, pageSize: number) => {
	const uri = `${BASE_URL}/gifts/search?page_size=${pageSize}&page_number=${pageNo}&value=${value}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};
export const api_createGift = async (payload: any) => {
	const uri = `${BASE_URL}/gifts`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the gift',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Gift created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_editGift = async (payload: any, giftId: string) => {
	const uri = `${BASE_URL}/gifts/${giftId}`;
	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the gift',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Gift edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteGift = async (giftId: string) => {
	const uri = `${BASE_URL}/gifts/remove/${giftId}`;
	const response = await fetch(uri, {
		method: 'DELETE',
		headers: {},
	}).then((res) => res.json());
	return response;
};
